import { render, staticRenderFns } from "./ComponentTreeItem.vue?vue&type=template&id=099dcecd"
import script from "./ComponentTreeItem.vue?vue&type=script&lang=js"
export * from "./ComponentTreeItem.vue?vue&type=script&lang=js"
import style0 from "./ComponentTreeItem.vue?vue&type=style&index=0&id=099dcecd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports